import { configInstance } from 'Contexts/ConfigContext';

const impactClaimPolicies = {
  ImpactClaim: {
    fields: {
      isPending: (value, { readField }) => {
        const pending = ['CREATED', 'UPDATED', 'REQUESTED', 'DOCUMENT_MISSING'];
        return pending.includes(readField('status'));
      },
      isApproved: (value, { readField }) => {
        return readField('status') === 'APPROVED';
      },
      isInvalid: (value, { readField }) => {
        return readField('status') === 'DENIED';
      },
      impactLevel: (value, { readField }) => {
        if (readField('product')) {
          return 'PRODUCT';
        }

        if (readField('component')) {
          return 'COMPONENT';
        }

        const assignedTo = readField('assignedTo');
        const createdBy = readField('createdBy');
        const assignedToId = readField('id', assignedTo);
        const createdById = readField('id', createdBy);

        if (assignedToId && assignedToId !== createdById) {
          return 'PARTNER';
        }

        return 'BUSINESS';
      },
      impactLevelTitle: (value, { readField }) => {
        const product = readField('product');
        if (product) {
          return readField('title', product);
        }

        const component = readField('component');
        if (component) {
          return readField('title', component);
        }

        const partner = readField('assignedTo');
        if (partner) {
          return readField('name', partner);
        }

        return null;
      },
    },
  },
  CmsImpactCatalogItem: {
    fields: {
      categoryConfig: (value, { readField }) => {
        const category = readField('category');
        return (
          configInstance.claimCategories[category?.type] ||
          configInstance.claimCategories.ECOLOGICAL
        );
      },
    },
  },
};

export default impactClaimPolicies;
